import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

const Container = styled.div`
  border-top: 1px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
`;

const AdRow = styled.div`
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  color: #000;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 44px;
  padding: 0 5px;
`;

const IndexLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 1px;
  margin-left: 3px;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 300;
`;

function AdList() {
  const store_tearsheet = store.tearsheet;
  const tearsheetAdsManager = store_tearsheet?.ads;

  // navigateTo is what switches the mobile view to the ad: it puts adIndex
  // into the URL, and TearsheetMobileView derives its mode from that param.
  const handleAdClick = (adId: string) => {
    tearsheetAdsManager?.getById(adId)?.navigateTo();
  };

  return (
    <Container>
      {(tearsheetAdsManager?.children || []).map((ad, i) => (
        <AdRow key={ad.id} onClick={() => handleAdClick(ad.id)}>
          <IndexLabel>{i + 1}</IndexLabel>
          <Label>{ad.data.label}</Label>
        </AdRow>
      ))}
    </Container>
  );
}

export default observer(AdList);
